<template>
  <NuxtLink
    :to="localePath(path)"
    class="also-read not-prose"
    :aria-label="`Also read: ${title}`"
  >
    <span class="also-read__eyebrow">Also read</span>
    <span class="also-read__row">
      <span class="also-read__title">{{ title }}</span>
      <span class="also-read__arrow" aria-hidden="true">&nbsp;-&gt;</span>
    </span>
  </NuxtLink>
</template>

<script setup>
defineProps({
  title: { type: String, required: true },
  path: { type: String, required: true },
});

const { localePath } = useWorkspaceLocale();
</script>

<style scoped>
.also-read {
  display: block;
  margin: 2rem 0;
  border: 1px solid #bfd5df;
  border-left: 4px solid #1ba7ce;
  border-radius: 10px;
  background: linear-gradient(180deg, #f2fafd 0%, #ffffff 100%);
  padding: 1.05rem 1.25rem;
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

/* Rendered inside .article-prose, whose deep styles underline anchors;
   the doubled class outranks that rule so the card stays underline-free. */
.also-read.also-read {
  text-decoration: none;
}

.also-read:hover {
  border-color: rgb(27 167 206 / 0.5);
  box-shadow: 0 14px 36px rgb(15 23 42 / 0.08);
}

.also-read__eyebrow {
  display: block;
  color: #0e7490;
  font-size: 0.72rem;
  font-weight: 900;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

/* The arrow flows after the title, joined to its last word by a no-break space
   and kept whole, so a long title on a phone never strands or splits it. */
.also-read__row {
  display: block;
  margin-top: 0.3rem;
}

.also-read__title {
  color: #0f172a;
  font-size: 1rem;
  font-weight: 850;
  line-height: 1.45;
}

.also-read__arrow {
  color: #1ba7ce;
  font-weight: 900;
  white-space: nowrap;
}

.dark .also-read {
  border-color: #1e3a4a;
  border-left-color: #1ba7ce;
  background: linear-gradient(180deg, #0d1b2d 0%, #0a1220 100%);
}

.dark .also-read__eyebrow {
  color: #67e8f9;
}

.dark .also-read__title {
  color: #f8fafc;
}

.dark .also-read__arrow {
  color: #67e8f9;
}
</style>
